var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras1.formBg)?_c('div',{staticClass:"m-wrap-new m-pc",style:({
    background:
      _vm.extras1.formBg.colorOrBg == 'color'
        ? _vm.extras1.formBg.color
        : 'url(' + _vm.extras1.formBg.src + ')',
  })},[(_vm.extras1 && _vm.extras1.formLogo.display == '1')?_c('div',{staticClass:"semianr-logo"},[_c('img',{attrs:{"src":_vm.isSetting != '1'
          ? _vm.extras1.headerLogo && _vm.extras1.headerLogo.src
          : './images/logo_new.png',"alt":""}})]):_vm._e(),(_vm.isSetting != '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.textSetting.display == '1')?_c('div',{staticClass:"seminar-info-new",class:_vm.extras1.BannerText.textAlign},[_c('div',{staticClass:"content"},[(_vm.extras1.textSetting.subTitle !== 'hide')?_c('div',{staticClass:"seminar-title",style:({
            color:
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" "+_vm._s(_vm.getSubTitleText())+" ")]):_vm._e(),(_vm.extras1.textSetting.title !== 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
            color:
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" "+_vm._s(_vm.getTitleText())+" ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[(_vm.extras1.textSetting.timeTitle !== 'hide')?_c('div',{staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.titleBgColor
                  ? _vm.extras1.textSetting.titleBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s(_vm.getTimeTitleText())+" ")]):_vm._e(),(_vm.extras1.textSetting.time !== 'hide')?_c('div',{staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.timeBgColor
                  ? _vm.extras1.textSetting.timeBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s(_vm.getTimeText())+" ")]):_vm._e()]),_c('div',{staticClass:"semianr-time"},[(_vm.extras1.textSetting.addressTitle !== 'hide')?_c('div',{staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.titleBgColor
                  ? _vm.extras1.textSetting.titleBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s(_vm.getAddressTitleText())+" ")]):_vm._e(),(_vm.extras1.textSetting.address !== 'hide')?_c('div',{staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.addressBgColor
                  ? _vm.extras1.textSetting.addressBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s(_vm.getAddressText())+" ")]):_vm._e()])])]):_vm._e()]):_vm._e(),(_vm.isSetting == '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.textSetting.display == '1')?_c('div',{staticClass:"seminar-info-new"},[_c('div',{staticClass:"content"},[(_vm.extras1.textSetting.subTitle !== 'hide')?_c('div',{staticClass:"seminar-title",style:({
            color:
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.subTitleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" 2023企业数字化峰会 ")]):_vm._e(),(_vm.extras1.textSetting.title !== 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
            color:
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontColor
                : '',
            'font-size':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontSize + 'px'
                : '',
            'font-weight':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontWeight == 'on'
                  ? '900'
                  : ''
                : '',
            'font-style':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.titleFontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
          })},[_vm._v(" 设计连接 新商业 ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[(_vm.extras1.textSetting.timeTitle !== 'hide')?_c('div',{staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.timeTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.titleBgColor
                  ? _vm.extras1.textSetting.titleBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s("会议时间")+" ")]):_vm._e(),(_vm.extras1.textSetting.time !== 'hide')?_c('div',{staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.timeFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.timeBgColor
                  ? _vm.extras1.textSetting.timeBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s("2023.12.12-12.13")+" ")]):_vm._e()]),_c('div',{staticClass:"semianr-time"},[(_vm.extras1.textSetting.addressTitle !== 'hide')?_c('div',{staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.addressTitle == 'custom'
                  ? _vm.extras1.textSetting.addressTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.titleBgColor
                  ? _vm.extras1.textSetting.titleBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s("会议地点")+" ")]):_vm._e(),(_vm.extras1.textSetting.address !== 'hide')?_c('div',{staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontColor
                  : '',
              'font-size':
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontSize + 'px'
                  : '',
              'font-weight':
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.address == 'custom'
                  ? _vm.extras1.textSetting.addressFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'background-color':
                _vm.extras1.textSetting && _vm.extras1.textSetting.addressBgColor
                  ? _vm.extras1.textSetting.addressBgColor
                  : 'transparent',
            })},[_vm._v(" "+_vm._s("北京市朝阳区高井文化园路8号")+" ")]):_vm._e()])])]):_vm._e()]):_vm._e(),_c('div',{staticClass:"field-area form1",style:({
      background: _vm.extras1.formFieldBg
        ? _vm.extras1.formFieldBg.colorOrBg == 'color'
          ? _vm.extras1.formFieldBg.color
          : 'url(\'' + _vm.extras1.formFieldBg.src.replace(/'/g, '\\\'') + '\')'
        : '',
    })},[_c('vue-scroll',{attrs:{"ops":_vm.ops}},[(
          _vm.extras1.formTitle &&
          _vm.extras1.formTitle.display == 1 &&
          _vm.formInfo.status != 2 &&
          !_vm.isTrackClosed
        )?_c('div',{staticClass:"title",class:_vm.extras1.formTitle && _vm.extras1.formTitle.textAlign,style:({
          'letter-spacing':
            _vm.extras1.formTitle && _vm.extras1.formTitle.wordWidth
              ? _vm.extras1.formTitle.wordWidth + 'px'
              : '',
        })},[_vm._v(" "+_vm._s(_vm.extras1.formTitle && _vm.extras1.formTitle.title)+" ")]):_vm._e(),(_vm.formInfo.status != 2 && !_vm.isTrackClosed)?_c('CField',{ref:"formRef",staticClass:"field-wrap new",attrs:{"formData":_vm.formData,"platform":_vm.platform,"rulesJump":_vm.rulesJump},on:{"update:rulesJump":function($event){_vm.rulesJump=$event},"update:rules-jump":function($event){_vm.rulesJump=$event}}}):_vm._e(),(_vm.formInfo.status == 2 || _vm.isTrackClosedMessage)?_c('div',{staticStyle:{"position":"absolute","top":"50%","width":"100%","transform":"translateY(-50%)"}},[_c('div',{staticClass:"u-success"},[_c('img',{attrs:{"src":_vm.imgUrlObj[_vm.platform]['over'],"alt":""}})]),_c('div',{staticClass:"split-line"}),_c('div',{staticClass:"title"},[_vm._v("报名已截止！")]),(_vm.formInfo.status == 1)?_c('div',[_c('div',{staticClass:"split-line"}),_c('div',{staticClass:"bottom",staticStyle:{"justify-content":"center"}},[(
                _vm.extras1.seminarButton && _vm.extras1.seminarButton.display == 1
              )?_c('a-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.formInfo.identity == 1),expression:"formInfo.identity == 1"}],staticClass:"btn-default mt-160",on:{"click":function($event){return _vm.togoVerifyNew()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras1,"seminarButton.text"))+" ")]):_vm._e()],1)]):_vm._e()]):(_vm.preview || _vm.formInfo.status == 1)?_c('div',[_c('div',{staticClass:"split-line"}),_c('div',{staticClass:"bottom"},[_c('a-button',{staticClass:"submit",style:({
              width:
                _vm.extras1.submitButton &&
                _vm.extras1.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras1.submitButton.width + '%'
                  : '',

              color:
                _vm.extras1.submitButton &&
                _vm.extras1.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras1.submitButton.fontColor
                  : '',

              'font-style':
                _vm.extras1.submitButton &&
                _vm.extras1.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras1.submitButton.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-weight':
                _vm.extras1.submitButton &&
                _vm.extras1.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras1.submitButton.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              'font-size':
                _vm.extras1.submitButton &&
                _vm.extras1.submitButton.buttonTextStyle == 'custom'
                  ? _vm.extras1.submitButton.fontSize + 'px'
                  : '',
            }),attrs:{"type":"primary","disabled":_vm.isSubmitting},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras1,"submitButton.text"))+" ")]),(_vm.extras1.seminarButton && _vm.extras1.seminarButton.display == 1)?_c('a-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.formInfo.identity == 1),expression:"formInfo.identity == 1"}],staticClass:"btn-default",on:{"click":function($event){return _vm.togoVerifyNew()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras1,"seminarButton.text"))+" ")]):_vm._e()],1)]):_vm._e()],1)],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }